module.exports = __webpack_public_path__ + "static/media/domherre.c33810d7.jpg";